var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Stack, Tooltip } from "@mui/material";
import { Checkbox, IconButton } from "../../../../Atoms";
import { COLORS } from "../../../../../constants";
var shadow = "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)";
var PopoverMenuCell = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.menuItems, menuItems = _c === void 0 ? [] : _c, _d = _a.selected, selected = _d === void 0 ? false : _d, open = _a.open, handleCheckboxClick = _a.handleCheckboxClick;
    if (selected) {
        return (_jsx(Checkbox, { "data-testid": "popovermenucell-selected", checked: true, onChange: function () {
                handleCheckboxClick && handleCheckboxClick(data);
            } }));
    }
    if (menuItems.length === 0) {
        return null;
    }
    return (_jsx(Box, __assign({ "data-testid": "popovermenu-cell" }, { children: _jsx(Tooltip, __assign({ title: _jsx(Stack, __assign({ direction: "row", "data-testid": "popovermenu-menu-items", spacing: 2 }, { children: menuItems.map(function (item) { return (_jsx(IconButton, __assign({ "data-testid": "popovermenu-button-".concat(item.id), onClick: function () {
                        item.onClick(data);
                    } }, { children: item.icon }), item.id)); }) })), placement: "left", open: open, componentsProps: {
                tooltip: {
                    sx: {
                        backgroundColor: COLORS.WHITE,
                        boxShadow: shadow,
                        border: "1px solid ".concat(COLORS.P_OUTLINE),
                        borderRadius: "100px",
                        mr: "-37px !important",
                        p: 1,
                    },
                },
            } }, { children: _jsx(Box, {}) })) })));
};
export default PopoverMenuCell;
